(() => {
  function launchProductImpressions(productNodes) {
    window.dataLayer = window.dataLayer || [];
    const impressions = [];
    const combinedRequests = [];
  
    productNodes.forEach(async (productNode) => {
      const { productHandle } = productNode.dataset;

      try {
        const productRequestUrls = [
          `${Shopify.routes.root}products/${productHandle}.js`,
          `${Shopify.routes.root}products/${productHandle}?view=json`,
        ];

        combinedRequests.push(Promise.all((productRequestUrls.map(async (url) => {
          const resp = await fetch(url);
          if (url.includes('json')) {
            return resp.json();
          }

          const json = await resp.json();
          let currentVariant = json.variants[0];
          const form = productNode.querySelector('product-form');
          if (form) {
            const variantId = parseInt(form.querySelector('input[name="id"]').value, 10);
            currentVariant = json.variants.find((variant) => variant.id === variantId);
          }
          return Object.assign(json, { currentVariant });
        }))));
      } catch (err) {
        console.error(err);
      }
    });

    Promise.all(combinedRequests).then((json) => {
      json.forEach((productData) => {
        const productDetails = productData[0];
        const productMetafields = productData[1];
        impressions.push({
          name: productDetails.title,
          id: productDetails.currentVariant.sku,
          price: productDetails.currentVariant.price / 100,
          brand: productDetails.vendor,
          category: productDetails.type,
          position: impressions.length + 1,
          dimension1: productDetails.currentVariant.title,
          dimension2: productDetails.currentVariant.id,
          dimension3: productMetafields.scent || "",
          dimension4: productMetafields.key_ingredient || "",
          dimension5: productMetafields.skin_type || "",
          dimension6: productMetafields.hair_type || ""
        });
      });

      window.dataLayer.push({
        event: 'productImpression',
        ecommerce: {
          currencyCode: Shopify.currency.active,
          impressions,
        },
      });

      console.log('%cEvent: productImpression', 'color: #FF9100');
      console.log(window.dataLayer);
    });
  }
  
  function checkForProducts() {
    const productNodes = document.querySelectorAll('[data-product-card]');
    const productNodesVisible = Array.from(productNodes).filter(element => element.clientWidth > 0)
    if (productNodesVisible.length) {
      launchProductImpressions(productNodesVisible);
    }
  }
  
  document.addEventListener('products:refresh', checkForProducts);
  checkForProducts();
})();